import HealthActionBar from "./HealthActionBar";
import AvatarMini from "components/commons/AvatarMini";
import AnonymousAvatarMini from "components/commons/AnonymousAvatarMini";
import { useTranslation } from "react-i18next";
import FormatDate from "utility/FormatDateHour";
import { NavLink } from "react-router-dom";
import { BpmStatus } from "./BpmStatus";
import { relativeTime } from "utility/TimeUtility";

const HealthRealtTimeCard = (
    {
        healthData,
        onAction = (userGuid, actionType) => { }
    }
) => {


    const MAX_DATA_AGE_SECONDS = 5 * 60 * 60; // 5 ore
    const RADIUS = 16 //px
    const BMP_WARNING_GAP = 5

    const [t] = useTranslation(["global"])
    const { user, hr, isOffBody, lastUpdate, minHr, maxHr } = healthData

    var delta = (Date.now() - lastUpdate * 1000)

    let veryHight = maxHr || 200;
    let hight = veryHight - BMP_WARNING_GAP;

    let veryLow = minHr || 20;
    let low = veryLow + BMP_WARNING_GAP;

    const status = calculateBpmStatus();
    const alpha = calculateAlpha();
    const color = bpmColor(status, alpha);


    function getSafeRangeColor() {

        if (hr == null || delta > 3600 * 1000 * 5) {
            return "bg-dark bg-opacity-25";
        }
        if (hr > low && hr < hight) {
            return "bg-dark bg-opacity-0";
        } else if ((hr >= hight && hr < veryHight) || (hr <= low && hr > veryLow)) {
            return "bg-warning bg-opacity-25";
        } else {
            return "bg-danger bg-opacity-25";
        }
    }

    function calculateAlpha(
        nowSeconds = Math.floor(Date.now() / 1000)
    ) {
        const age = Math.max(0, nowSeconds - lastUpdate);

        return age >= MAX_DATA_AGE_SECONDS
            ? 0
            : 1 - age / MAX_DATA_AGE_SECONDS;
    }

    function calculateBpmStatus() {
        if (isOffBody === true) {
            return BpmStatus.OFF_BODY;
        }

        if (hr == null) {
            return BpmStatus.READING;
        }

        if (hr < veryLow || hr > veryHight) {
            return BpmStatus.DANGER;
        }

        if (hr <= low || hr >= hight) {
            return BpmStatus.WARNING;
        }

        return BpmStatus.NORMAL;
    }

    function bpmColor(status, alpha) {
        switch (status) {
            case BpmStatus.DANGER:
                return `rgba(220, 53, 69, ${alpha})`; // bootstrap danger

            case BpmStatus.WARNING:
                return `rgba(255, 193, 7, ${alpha})`; // bootstrap warning

            case BpmStatus.NORMAL:
                return `rgba(25, 135, 84, ${alpha})`; // bootstrap primary

            case BpmStatus.OFF_BODY:
                return `rgba(108, 117, 125, 0)`; // invisible

            case BpmStatus.READING:
                return `rgba(108, 117, 125, ${alpha})`; // bootstrap secondary

            default:
                return `rgba(0, 0, 0, ${alpha})`;
        }
    }


    function getHeartIcon() {
        if (hr == null) {
            return;
        }
        if (hr > low && hr < hight) {
            return <i className="fa-solid fa-heart fa-fade text-danger"></i>;
        } else if ((hr >= hight && hr < veryHight) || (hr <= low && hr > veryLow)) {
            return <i className="fa-solid fa-heart-circle-exclamation fa-beat text-warning"></i>;
        } else {
            return <i className="fa-solid fa-heart-circle-exclamation fa-beat text-danger"></i>;
        }
    }

    return <div className={`col `}>
        <div className={`col card ${getSafeRangeColor()}   text-white h-100 d-flex flex-column`} style={{ borderColor: color, borderWidth: 4, borderRadius: RADIUS }}>

            {/* <div style={{ borderTopLeftRadius: RADIUS, borderTopRightRadius: RADIUS }}> */}
            {
                user.guid.length > 1 ?
                    <AvatarMini
                        displayName={user.displayName}
                        guid={user.guid}
                        destination="/dashboard/health/history"
                        style={{ borderTopLeftRadius: RADIUS, borderTopRightRadius: RADIUS }}
                    />
                    : <AnonymousAvatarMini style={{ borderTopLeftRadius: RADIUS, borderTopRightRadius: RADIUS }} />
            }
            {/* </div> */}
            <div className={`card-body d-flex flex-column `}>
                <div className="d-flex align-items-center">
                    <div className="col-auto">

                        <HealthActionBar onAction={(actionType) => onAction(user.guid, actionType)} />
                    </div>
                    <div className={`col text-end `} style={{ opacity: alpha }}>

                        {
                            status == BpmStatus.OFF_BODY &&
                            <h5><i className="fa-solid fa-hand"></i> OffBody</h5>
                        }

                        {
                            status == BpmStatus.READING &&
                            <>
                                <div className="spinner-border hidden text-light" role="status"></div>
                            </>
                        }

                        {
                            status != BpmStatus.OFF_BODY && status != BpmStatus.READING &&
                            <>
                                <span className={`h2 font-bold p-1`}>
                                    {getHeartIcon()} {hr}
                                </span>
                                <small className="text-muted">bpm</small>
                            </>
                        }



                    </div>
                </div>
            </div>
            <div className={`card-footer d-flex justify-content-between align-items-center opacity-100`}>
                <NavLink to={{ pathname: "/dashboard/health/history" }} state={{ userGUID: user.guid }}><button className="btn btn-success"><i className="fa-solid fa-square-poll-vertical"></i> Dati</button></NavLink>
                <small className="text-muted"> {relativeTime(lastUpdate)}</small>
            </div>
        </div>
    </div>
}

export default HealthRealtTimeCard